import { emailValidate } from "../../../../components/Common/form-validations"
import InlineInputAddress from "../../../../components/Common/InlineInputAddress";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { updateUserInfoAsync } from "../../userSlice";

function EmailAddressForm() {
    const { register, handleSubmit, getFieldState, setValue, getValues, formState: { errors, isValid, submitCount, isSubmitting } } = useForm();
    const [emailEditMode, setemailEditMode] = useState(false);
    const [defaultValueEmail, setDefaultValueEmail] = useState({ 'email': '' });
    const userDetails = useSelector((state) => state.user.userInfo);
    const dispatch = useDispatch();

    const toggleEditMode = () => {
        const emailValue = getValues("email");
        if (emailValue === "") { //This run when user backspace the input default values and click cancel
            setValue('email', defaultValueEmail.email);
        }
        setemailEditMode(!emailEditMode);
    };

    const submitEmail = (data) => {
        if (isValid) {
            dispatch(updateUserInfoAsync({ userId: userDetails.id, change: { email: data.email } })).then(() => {
                setemailEditMode(!emailEditMode);
            })
            //to do user ko email verify karna hai abhi direct horha h update
        }
    }

    useEffect(() => {
        setDefaultValueEmail({ email: userDetails.email });
        setValue('email', userDetails.email); // Set the default value
    }, [setValue, userDetails]);

    return (userDetails &&
        <form noValidate={true} onSubmit={handleSubmit(submitEmail)}>
            <div className="flex items-baseline" aria-labelledby="Update Name" aria-placeholder="Update Personal Information">
                <p className="text-base font-bold tracking-tight text-gray-900">Email Address</p>
                <button type="button" onClick={toggleEditMode} className="ms-4 text-sm font-medium tracking-tight text-indigo-600"> {emailEditMode ? 'Cancel' : 'Edit'}</button>
            </div>
            <div className="grid items-center md:grid-cols-3 gap-3 md:gap-6 mt-4 mb-2">
                <div className="relative">
                    <InlineInputAddress type="email" disabled={!emailEditMode} label={`${emailEditMode ? "Email Address" : ""}`} classname="!text-gray-500" submitCount={submitCount} getFieldState={getFieldState("email")} errors={errors.email} autoComplete="off" {...register("email", { ...emailValidate })} />
                </div>

                <div className="relative">
                    <button type="submit" className={`${emailEditMode ? "inline" : "hidden"} mx-auto py-3 px-5 rounded-md border-[1px] bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:border-indigo-100 text-sm font-medium text-white shadow-md`} style={{ borderColor: "#0000" }}>{isSubmitting ? "Saving..." : "Save"}</button>
                </div>
            </div>
        </form>
    );
}

export default EmailAddressForm;